module.exports = __webpack_public_path__ + "img/erp.35083423.png";